module.exports = __webpack_public_path__ + "static/media/who-white-small-logo.dfda2d03.svg";